import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["id", "icon", "className", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useContext } from 'react';
import classNames from 'classnames';
import { ListContext } from './ListContext';
import "./list.css";
export var ListItem = function ListItem(_ref) {
  var id = _ref.id,
    icon = _ref.icon,
    className = _ref.className,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var listContext = useContext(ListContext);
  var variant = listContext === null || listContext === void 0 ? void 0 : listContext.variant;
  var listIcon = icon || (listContext === null || listContext === void 0 ? void 0 : listContext.getIcon());
  var classes = classNames('lm-ListItem', 'lmig-ListItem', {
    'lm-ListItem--withIcon': !!listIcon && variant !== 'ordered'
  }, className);
  var normalizedIcon = listIcon ? /*#__PURE__*/React.cloneElement(listIcon, {
    size: listIcon.props.size || '16',
    // if no size is specified, default to 16
    ariaHidden: true,
    title: null,
    className: 'lm-ListItem--icon'
  }) : undefined;
  return /*#__PURE__*/React.createElement("li", _extends({
    id: id,
    className: classes
  }, otherProps), variant === 'ordered' ? /*#__PURE__*/React.createElement("div", {
    className: "lm-ListItem-number"
  }) : normalizedIcon, /*#__PURE__*/React.createElement("div", {
    className: "lm-ListItem--text"
  }, children));
};
ListItem.propTypes = {
  /** Add an optional ID to this element: `<li class="lm-ListItem">`. */id: _pt.string,
  /** Use with unordered lists if a custom bullet is desired. Pass an instance of an LMDS icon. */icon: _pt.element,
  /** Add custom classes to this element: `<li class="lm-ListItem">`. */className: _pt.string,
  /** Pass list item content as children to this element: `<div class="lm-ListItem--text">`. */children: _pt.node
};